import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ModalService } from '../../modal/modal.service';
import { UserService } from '../../services/user/user.service';

export interface CanComponentDeactivate {
  canDeactivate: () =>
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree;
}

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard  {
  private _modals = inject(ModalService);
  private _user = inject(UserService);

  private openedModal = false;

  async canDeactivate(
    component: CanComponentDeactivate,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    next: RouterStateSnapshot
  ) {
    if (!this.openedModal && !next.url.includes('login') && !next.url.includes('register') && !this._user.isUserAlreadyRegistered) {
      const component = await import('../../modal/components/lazy/register-leave/register-leave.component');
      await this._modals.openLazy(component?.RegisterLeaveComponent,
        {
          data: next.url
        }
      );
      this.openedModal = true;
      return false;
    } else {
      return true;
    }
  }

}
